const state = {
  tabsNum: 1, // 财务审核
  subCurrent: 1, // 财务审核

  tabsNumF: 1, // 对账管理
  subCurrentF: 1 // 对账管理
}

const mutations = {
  tabChange(state, params) {
    state.tabsNum = params
  },
  tabChangeF(state, params) {
    state.tabsNumF = params
  },
  subChange(state, params) {
    state.subCurrent = params
  },
  subChangeF(state, params) {
    state.subCurrentF = params
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
